import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';

import { RegistrationPassword } from '../../models/registrationpassword';

/**
 * Generated class for the UpdateRegistrationPasswordPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-password',
  templateUrl: 'update-registration-password.html',
})
export class UpdateRegistrationPasswordPage {

  public registrationPassword: RegistrationPassword;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider
  ) {
    this.registrationPassword = new RegistrationPassword();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationPasswordPage');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doSave() {
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar a senha.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationPassword.password)) {
      this.alertProvider.doAlert('Forneça sua senha atual.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationPassword.newPassword)) {
      this.alertProvider.doAlert('Forneça a nova senha.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationPassword.newPasswordCheck)) {
      this.alertProvider.doAlert('Forneça a confirmação da nova senha.', 'Atenção');
    } else if (this.registrationPassword.newPassword !== this.registrationPassword.newPasswordCheck) {
      this.alertProvider.doAlert('A confirmação da nova senha não confere.', 'Atenção');
    } else if (this.registrationPassword.password === this.registrationPassword.newPassword) {
      this.alertProvider.doAlert('A nova senha é igual a sua senha atual.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Você deseja mudar sua senha?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        that.authProvider.updatePassword(that.registrationPassword).subscribe(response => {
          if ((response) && (response.updated)) {
            that.alertProvider.doAlert('Sua senha foi alterada com sucesso.', 'Informação');
            // TODO: Get out from application
            loader.dismiss();

            // TODO: Verify if its using Wifi mode and warn if not
            // DONE: Bug when #popTo direct to ProofListPage
            // that.navCtrl.popTo(that.navCtrl.getByIndex(0));
            // TODO: Change to ProofListPage
            that.onBack();
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Verique se as senhas estão corretas.', 'Atenção');
          }
        }, error => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Verique se as senhas estão corretas.', 'Atenção');
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-password/update-registration-password.ts